export class RentalHistory {
    constructor (
        public RentalEmployerKey: number = 0,
        public RentalHistoryKey: number = 0,
        public Address: string = '',
        public City: string = '',
        public State: string = '',
        public Zip: string = '',
        public RentAmount: number = null,
        public StartDate: Date = null,
        public EndDate: Date = null,
        public ManagerName: string = '',
        public ManagerPhone: string = '',
        public RentalMoveInReasonKey: number = null,
        public IsCurrent: boolean = false
    ) { }
}
